var React = require('react');

function InfoIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M.2 0C.09 0 0 .09 0 .2s.09.2.2.2S.4.31.4.2.31 0 .2 0zm0 .37C.11.37.03.29.03.2S.11.03.2.03.37.11.37.2.29.37.2.37z","key":1}),React.createElement("path",{"d":"M.2.17C.19.17.18.18.18.19v.1C.18.3.19.31.2.31S.22.3.22.29v-.1C.22.18.21.17.2.17z","key":2}),React.createElement("circle",{"cx":".2","cy":".13","r":".02","key":3})]);
}

InfoIcon.defaultProps = {"fillRule":"evenodd","fill":"currentColor","clipRule":"evenodd","imageRendering":"optimizeQuality","shapeRendering":"geometricPrecision","textRendering":"geometricPrecision","viewBox":"0 0 .4 .4"};

module.exports = InfoIcon;

InfoIcon.default = InfoIcon;
